export const Main = r => require.ensure([], () => r(require('../../Core/components/Main')), 'Report-bundle')
export const ListReportEquipment = r => require.ensure([], () => r(require('../../Report/components/Equipment/ListReportEquipment')), 'Report-bundle')
export const ListReportTerminal = r => require.ensure([], () => r(require('../../Report/components/Terminal/ListReportTerminal')), 'Report-bundle')
export const ListReportEc = r => require.ensure([], () => r(require('../../Report/components/EstabelecimentoComercial/ListReportEstaComercial')), 'Report-bundle')
export const ListReportTransacoes = r => require.ensure([], () => r(require('../../Report/components/Transactions/ListReportTransacoes')), 'Report-bundle')
export const ListReportTransacoesV3 = r => require.ensure([], () => r(require('../../Report/components/TransactionsV3/ListReportTransacoes')), 'Report-bundle')
export const ListReportRecebiveis = r => require.ensure([], () => r(require('../../Report/components/Receivables/ListReportRecebiveis')), 'Report-bundle')
export const ListReportMarketplaceRecebiveis = r => require.ensure([], () => r(require('../../Report/components/MarketplaceReceivables/ListReportMarketplaceRecebiveis')), 'Report-bundle')
export const ListReportRecebiveisV3 = r => require.ensure([], () => r(require('../../Report/components/ReceivablesV3/ListReportRecebiveis')), 'Report-bundle')
export const ListReportConciliationStone = r => require.ensure([], () => r(require('../../Report/components/ConciliationStone/ListReportConciliationStone')), 'Report-bundle')
export const ListReportConciliationStoneV3 = r => require.ensure([], () => r(require('../../Report/components/ConciliationStoneV3/ListReportConciliationStone')), 'Report-bundle')
export const ListReportAjustFinanceiro = r => require.ensure([], () => r(require('../../Report/components/AjustFinanceiro/ListReportAjustFinanceiro')), 'Report-bundle')
export const ListReportCustomer = r => require.ensure([], () => r(require('../../Report/components/Customer/ListReportCustomer')), 'Report-bundle')
export const ListReportRiskAnalysis = r => require.ensure([], () => r(require('../../Report/components/AnaliseRisco/ListReportRiskAnalysis')), 'Report-bundle')
export const ReportIntegrationMerchant = r => require.ensure([], () => r(require('../components/IntegrationMerchant/ReportIntegrationMerchant.vue')), 'Report-bundle')
export const ReportIntegrationReseller = r => require.ensure([], () => r(require('../components/IntegrationReseller/ReportIntegrationReseller.vue')), 'Report-bundle')

const children = [
  {
    name: 'report.ajustFinanceiro.index',
    path: 'ajuste-financeiro',
    component: ListReportAjustFinanceiro,
    meta: {
      requiresAuth: true,
      title: 'Lançamentos Financeiros',
      titleMenu: 'Lançamentos Financeiros',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Lançamentos Financeiros',
          pathName: 'report.ajustFinanceiro.index'
        },
      ]
    }
  },
  {
    name: 'report.transaction.index',
    path: 'transaction',
    component: ListReportTransacoes,
    meta: {
      requiresAuth: true,
      title: 'Relatório de transações',
      titleMenu: 'Transações',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Relatório de transações',
          pathName: 'report.transaction.index'
        },
      ]
    }
  },
  {
    name: 'report.transactionv3.index',
    path: 'transactionv3',
    component: ListReportTransacoesV3,
    meta: {
      requiresAuth: true,
      title: 'Relatório de transações (MongoDB)',
      titleMenu: 'Transações MongoDB',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Relatório de transações (MongoDB)',
          pathName: 'report.transactionv3.index'
        },
      ]
    }
  },
  {
    name: 'report.receivables.index',
    path: 'receivables',
    component: ListReportRecebiveis,
    meta: {
      requiresAuth: true,
      title: 'Relatório de Recebíveis ',
      titleMenu: 'Recebíveis',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Relatório de Recebíveis',
          pathName: 'report.receivables.index'
        },
      ]
    }
  },
  {
    name: 'report.marketplace_receivables.index',
    path: 'marketplace-receivables',
    component: ListReportMarketplaceRecebiveis,
    meta: {
      requiresAuth: true,
      title: 'Relatório de Recebíveis de Marketplace',
      titleMenu: 'Recebíveis de Marketplace',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Relatório de Recebíveis de Marketplace',
          pathName: 'report.marketplace_receivables.index'
        },
      ]
    }
  },
  {
    name: 'report.receivablesv3.index',
    path: 'receivablesv3',
    component: ListReportRecebiveisV3,
    meta: {
      requiresAuth: true,
      title: 'Relatório de Recebíveis (MongoDB)',
      titleMenu: 'Recebíveis MongoDB',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Relatório de Recebíveis (MongoDB)',
          pathName: 'report.receivablesv3.index'
        },
      ]
    }
  },
  {
    name: 'report.conciliationStone.index',
    path: 'conciliationStone',
    component: ListReportConciliationStone,
    meta: {
      requiresAuth: true,
      title: 'Relatório de Conciliação Stone',
      titleMenu: 'Conciliação Stone',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Relatório de Conciliação Stone',
          pathName: 'report.conciliationStone.index'
        },
      ]
    }
  },
  {
    name: 'report.conciliationStonev3.index',
    path: 'conciliationStonev3',
    component: ListReportConciliationStoneV3,
    meta: {
      requiresAuth: true,
      title: 'Relatório de Conciliação Stone (MongoDB)',
      titleMenu: 'Conciliação Stone MongoDB',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Relatório de Conciliação Stone (MongoDB)',
          pathName: 'report.conciliationStonev3.index'
        },
      ]
    }
  },
  {
    name: 'report.equipment.index',
    path: 'equipamentos',
    component: ListReportEquipment,
    meta: {
      requiresAuth: true,
      title: 'Relatório de equipamentos',
      titleMenu: 'Equipamentos',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Relatório de equipamentos',
          pathName: 'report.equipment.index'
        },
      ]
    }
  },
  {
    name: 'report.terminal.index',
    path: 'terminais',
    component: ListReportTerminal,
    meta: {
      requiresAuth: true,
      title: 'Relatório de terminais',
      titleMenu: 'Terminais',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Relatório de terminais',
          pathName: 'report.terminal.index'
        },
      ]
    }
  },
  {
    name: 'report.ec.index',
    path: 'estabelecimento-comercial',
    component: ListReportEc,
    meta: {
      requiresAuth: true,
      title: 'Relatório de Estabelecimentos Comerciais',
      titleMenu: 'Estabelecimentos Comerciais',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Relatório de Estabelecimentos Comerciais',
          pathName: 'report.ec.index'
        },
      ]
    }
  },
  {
    name: 'report.customer.index',
    path: 'clientes',
    component: ListReportCustomer,
    meta: {
      requiresAuth: true,
      title: 'Relatório de Clientes',
      titleMenu: 'Clientes',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Relatório de Clientes',
          pathName: 'report.customer.index'
        },
      ]
    }
  },
  {
    name: 'report.riskAnalysis.index',
    path: 'analise-risco',
    component: ListReportRiskAnalysis,
    meta: {
      requiresAuth: true,
      title: 'Análise de Risco',
      titleMenu: 'Análise de Risco',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Análise de Risco',
          pathName: 'report.riskAnalysis.index'
        },
      ]
    }
  },
  {
    name: 'report.integrationMerchant.index',
    path: 'integration-merchant',
    component: ReportIntegrationMerchant,
    meta: {
      requiresAuth: true,
      title: 'Integração Merchant',
      titleMenu: 'Integração Merchant',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Integração Merchant',
          pathName: 'report.integrationMerchant.index'
        },
      ]
    }
  },
  {
    name: 'report.integrationReseller.index',
    path: 'integration-reseller',
    component: ReportIntegrationReseller,
    meta: {
      requiresAuth: true,
      title: 'Integração Reseller',
      titleMenu: 'Integração Reseller',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Integração Reseller',
          pathName: 'report.integrationReseller.index'
        },
      ]
    }
  },
]

export default [{
  name: 'report',
  children,
  path: '/relatorios',
  component: Main,
  redirect: { name: 'home.index' },
  meta: {
    requiresAuth: true,
  }
}]
